export const WEBSITE_SITE_OPTIONS = [
  { value: 'airport-transfers-taxi', label: 'Airport Transfers Taxi' },
  { value: 'uk-airport-taxi', label: 'UK Airport Taxi Transfers' },
  { value: 'southampton-port-taxi', label: 'Southampton Port Taxi' },
  { value: 'liverpool-dock-taxi', label: 'Liverpool Docks Taxi' },
] as const;

export const WEBSITE_CONTENT_TYPES = [
  { value: 'sections', label: 'Sections (Privacy / Terms style)' },
  { value: 'about', label: 'About' },
  { value: 'services', label: 'Services' },
  { value: 'areas', label: 'Areas' },
  { value: 'faq', label: 'FAQ' },
  { value: 'contact', label: 'Contact' },
  { value: 'fleet', label: 'Fleet' },
  { value: 'meet-and-greet', label: 'Meet & Greet' },
  { value: 'custom', label: 'Custom JSON' },
] as const;

export type ContentSection = {
  title: string;
  paragraphs: string[];
};

export type WebsitePageRecord = {
  id: string;
  siteKey: string;
  slug: string;
  title: string;
  subtitle: string | null;
  metaTitle: string | null;
  metaDescription: string | null;
  contentType: string;
  content: unknown;
  published: boolean;
  sortOrder: number;
};

export function siteLabel(siteKey: string): string {
  return WEBSITE_SITE_OPTIONS.find((s) => s.value === siteKey)?.label ?? siteKey;
}

export function emptySectionsContent(): { sections: ContentSection[] } {
  return {
    sections: [{ title: 'Introduction', paragraphs: [''] }],
  };
}

export function parseSectionsContent(content: unknown): ContentSection[] {
  if (!content || typeof content !== 'object') return emptySectionsContent().sections;
  const sections = (content as { sections?: unknown }).sections;
  if (!Array.isArray(sections) || sections.length === 0) {
    return emptySectionsContent().sections;
  }
  return sections.map((raw) => {
    const item = raw as { title?: unknown; paragraphs?: unknown };
    return {
      title: typeof item.title === 'string' ? item.title : '',
      paragraphs: Array.isArray(item.paragraphs)
        ? item.paragraphs.map((p) => String(p ?? ''))
        : [''],
    };
  });
}
